import { AffichageDrevComponent } from './affichage-drev.component';

export const AFFICHAGE_DREV_ROUTES = [
    { path: '', component: AffichageDrevComponent },
    { path: ':annee', component: AffichageDrevComponent }
];
